var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input-text-base',{staticClass:"input-text",on:{"input":_vm.inputEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }